import { Component, Inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ActivityInterface } from '@sport-activities/sdk';

import { Type } from '~/component/form/input/enums/type.enum';
import { FormGroupValueInterface } from '~/component/form/interfaces/form-group-value.interface';
import { FormControlService } from '~/core/services/form/form-control.service';
import { RoutingInterface } from '~/core/services/navigation/interfaces/routing.interface';
import { NavigationService } from '~/core/services/navigation/navigation.service';
import { TitleService } from '~/core/services/title/title.service';
import { AbstractOrganizerActivityCreationFormPageDirective } from '~/organizer/activity-creation/components/shared/form-wrapper/classes/abstract-activity-creation-form-page';
import { NAVIGATION_ROUTING } from '~/organizer/shared/components/shared/navigation-buttons/navigation-buttons.component';
import { OrganizerSharedActivityService } from '~/organizer/shared/services/activity/activity.service';
import { OrganizerSharedOrganizationService } from '~/organizer/shared/services/organization/organization.service';

@Component({
  selector: 'app-organizer-activity-creation-group-size',
  templateUrl: './group-size.component.html',
  styleUrls: [
    '../../../../../organizer/shared/components/shared/form-wrapper/form-wrapper.component.scss',
  ],
})
export class OrganizerActivityCreationPageGroupSizeComponent extends AbstractOrganizerActivityCreationFormPageDirective {
  protected readonly pageTitleKey =
    'seo.organizer.activity_creation.group_size.title';
  public readonly inputType = Type.Number;
  public readonly minimumGroupSize = 1;
  public displayValidationError = false;

  constructor(
    protected readonly activatedRoute: ActivatedRoute,
    protected readonly activityService: OrganizerSharedActivityService,
    protected readonly formBuilder: FormBuilder,
    protected readonly navigationService: NavigationService,
    protected readonly organizationService: OrganizerSharedOrganizationService,
    @Inject(NAVIGATION_ROUTING)
    protected readonly navigationRouting: RoutingInterface[],
    protected readonly titleService: TitleService,
    private readonly formControlService: FormControlService
  ) {
    super(
      activatedRoute,
      activityService,
      formBuilder,
      navigationService,
      organizationService,
      navigationRouting,
      titleService
    );
  }

  protected buildDataBeforeSubmit(
    formGroupValue: FormGroupValueInterface
  ): Partial<ActivityInterface> {
    return {
      indicativeMaximumAttendeeCapacity: Number(formGroupValue.groupSize),
    };
  }

  protected buildValidationConfig(): void {
    const activity = this.activityService.activity;

    this.validationConfig = {
      groupSize: [
        activity.indicativeMaximumAttendeeCapacity || null,
        [Validators.required, Validators.min(this.minimumGroupSize)],
      ],
    };
  }

  public errorMessages(inputName: string): string[] {
    const control = this.formGroup.get(inputName);
    return (
      this.displayValidationError &&
      this.formControlService.getErrorMessages(control, inputName)
    );
  }

  public submit(formGroupValue: FormGroupValueInterface): void {
    if (this.formGroup.invalid) {
      this.displayValidationError = true;
      return;
    }

    super.submit(formGroupValue);
  }
}
